module.exports = __webpack_public_path__ + "static/media/sustainableGrey.0cf8e227.svg";